

























































































































































































































































































































































































import { PropType, defineComponent, computed, ComputedRef, ref, onMounted, getCurrentInstance } from '@vue/composition-api';
import { Message, ReportData } from '../../../dataType';
import { useLocale } from '../../../hooks/useLocale';
import { useCommonHooks, calcRemainingDays, formatRemindTime } from './help';
import {
  StatisticType,
  GroupData,
  RiskSituation,
  SprintProgressCard,
  RiskStatisticType,
  UserProgressType,
  LevelType,
  BurnDownType
} from './type';
import { useRender } from '../../../hooks/useRender';
import { isOverseasVersion } from 'common-module/src/util';
import AsyncLoading from './async-loading.vue';
// @ts-ignore
// import RobotIcon from './images/robot.svg';
import RobotIcon from 'common-module/src/assets/ai-summarize-robot.png';

type ActualDataType = (string | number | undefined)[][];

export default defineComponent({
  components: {
    AsyncLoading
  },
  props: {
    message: {
      type: Object as PropType<Message<ReportData<any>>>,
      required: true
    }
  },
  setup(props) {
    const { t, tc } = useLocale();
    const showUserProgress = ref(false);
    const instance = getCurrentInstance();
    const showSegment = ref(false);
    const remainDay = ref({
      isToday: false,
      days: 0,
      isOverdue: false
    });
    const importECharts = () => {
      // @ts-ignore
      return window.importByCDN('echarts');
    };
    const showDailyField: Array<('overDueWorkRisk' | 'memberRisk' | 'progressRisk' | 'taskRisk')
      & (keyof RiskSituation)> = ['overDueWorkRisk', 'memberRisk', 'progressRisk', 'taskRisk'];
    const reportData = computed(() => {
      return props.message.content.report.reportData as SprintProgressCard;
    });
    const riskSituation = reportData.value.riskSituation as RiskSituation;
    const reportType = props.message.content.report.reportType;
    const sourceMemberProgressUsers = computed(() => {
      return reportData.value.progressDetails.memberProgress.users || [];
    });
    const memberProgressUsers = computed(() => {
      if (!showUserProgress.value) {
        return sourceMemberProgressUsers.value.slice(0, 3);
      }
      return sourceMemberProgressUsers.value;
    });
    const workStatisticType = computed(() => reportData.value.workStatisticType) as ComputedRef<StatisticType>;
    const riskUnit = {
      overDueWorkRisk: (num: number) => tc('common.count.issueCountAre', num, { num }),
      memberRisk:(num: number) => tc('common.count.memberAre', num, { num }),
      progressRisk: () => '',
      taskRisk: (num: number) => tc('common.count.issueCountAre', num, { num })
    };
    const levelUnit = {
      3: t('saas.robotChat.High'),
      2: t('saas.robotChat.Medium'),
      1: t('saas.robotChat.Low'),
      0: t('saas.robotChat.None')
    };
    const iconMap = {
      taskRisk: 'zkicon iconshijianriqi',
      memberRisk: 'zkicon iconrenyuan',
      overDueWorkRisk: 'zkicon icongongzuoyanqi',
      progressRisk: 'zkicon iconjindutiao'
    };
    const isNumber = (num: number | string | undefined) => !isNaN(Number(num));
    const calcLabourUnit = (second: number | undefined) => {
      if (isNumber(second)) {
        return Math.round((Number(second)) / 60 / 60 * 10000) / 10000;
      }
      return second;
    };
    const tipsByRiskMap = {
      memberRisk: {
        0: '',
        1: t('saas.robotChat.memberRiskTipsLow'),
        2: t('saas.robotChat.memberRiskTipsMedium'),
        3: t('saas.robotChat.memberRiskTipsHigh')
      },
      overDueWorkRisk: {
        0: '',
        1: t('saas.robotChat.overDueWorkRiskTipsLow'),
        2: t('saas.robotChat.overDueWorkRiskTipsMedium'),
        3: t('saas.robotChat.overDueWorkRiskTipsHigh')
      },
      taskRisk: {
        0: '',
        1: t('saas.robotChat.taskRiskTipsLow'),
        2: t('saas.robotChat.taskRiskTipsMedium'),
        3: t('saas.robotChat.taskRiskTipsHigh')
      },
      progressRisk: {
        0: '',
        1: t('saas.robotChat.progressRiskTipsLow'),
        2: t('saas.robotChat.progressRiskTipsMedium'),
        3: t('saas.robotChat.progressRiskTipsHigh')
      }
    };

    const {
      processTranslateMap,
      transformMemberListNeedData
    } = useCommonHooks();
    const unitTranslateMap = {
      point: (num: number) => (`${num} ${tc('home.chartWidget.point', num)}`),
      labour: (num: number) => `${num} h`,
      issueCount: (num: number) => `${num} ${tc('common.count.issue', num)}`
    };
    const listMap = computed(() => {
      return showDailyField.map(key => {
        return {
          key,
          ...(riskSituation[key])
        };
      });
    });
    const riskUserList = computed(() => riskSituation.memberRisk?.users || []);
    const { openAside } = useRender();
    const openAsideComponent = (
      issueIds: Array<number>,
      type: string,
      hasGroup?: Array<GroupData> | null,
      key?: RiskStatisticType | 'riskSituation' | '',
      level?: LevelType | '',
      trackType?: string,
      trackParam?: any
    ) => {
      if (!issueIds) {
        return;
      }
      let showHeaderTips = '';
      if (key === 'riskSituation') {
        showHeaderTips = t('saas.robotChat.riskTipsCommon');
      } else if (key && level) {
        showHeaderTips = tipsByRiskMap[key][level];
      }
      openAside(() => import('../../aside-component/IssueList.vue'), {
        ...props.message,
        title: `${t('backlog.Sprint')}: ${reportData.value.sprintName} ${type}`,
        showHeaderTips,
        content: {
          issueIds: issueIds,
          showStayDays: true,
          loadListById: true,
          hasGroup
        }
      });

      if (trackType) {
        instance?.proxy.$track.send(trackType, trackParam, true);
      }
    };

    const summaryList = computed(() => {
      return reportData.value.summary;
    });
    const chartError = computed(() => {
      return reportData.value.burnDown?.errorMsg;
    });
    const chartData = computed(() => {
      if (chartError.value) {
        return [];
      }
      return reportData.value.burnDown.data?.filter(item => {
        return (item.isWeekend !== 1) || item.isFirstDate;
      })?.map(item => {
        if (workStatisticType.value === 'labour') {
          return {
            ...item,
            estimateLabourCount: calcLabourUnit(item.estimateLabourCount),
            burnupRangeVo: {
              ...item.burnupRangeVo,
              countValue: calcLabourUnit(item.burnupRangeVo?.countValue)
            }
          };
        }
        return item;
      }) || [];
    });
    const showChartStatistic = ref<StatisticType>('point');
    const workItemsKey = computed(() => {
      if (workStatisticType.value === 'point' && showChartStatistic.value === 'point') {
        return 'pointCount';
      }
      if (workStatisticType.value === 'labour' && showChartStatistic.value === 'labour') {
        return 'estimateLabourCount';
      }
      return 'issueCount';
    });
    const actualData = computed(():ActualDataType => {
      return chartData.value.map((item) => {
        return item.isFirstDate === 1 ? ['', item[workItemsKey.value]] : [item.formatTime, item[workItemsKey.value]];
      });
    });
    const fIndex = chartData.value.findIndex((item) => {
      return Object.prototype.hasOwnProperty.call(item, 'allIssueIds') && item.isFirstDate === 0;
    });
    const currentIndex = fIndex > -1 ? fIndex : (actualData.value.length - 1);
    const currentChartNumber = ref<{
      total: number | string | undefined,
      actualNumber: number | string,
      idealNumber: number | string,
      actualPercent: number | string,
      idealPercent: number | string,
      unfinishedIssueIds: number[],
      allIssueIds: number[]
    }>({
      total: 0,
      actualNumber: 0,
      idealNumber: 0,
      actualPercent: 0,
      idealPercent: 0,
      unfinishedIssueIds: [],
      allIssueIds: []
    });
    const noWordDayRange:number[] = [];
    const idealData = computed(():ActualDataType => {
      const isNoWeekendDay = chartData.value.filter(item => {
        return (!item.isWeekend && !item.isFirstDate);
      }).length;
      const allDay = Math.max(isNoWeekendDay, 0);
      const first = chartData.value?.[0] || {};
      const total = typeof first[workItemsKey.value] === 'number' ? first[workItemsKey.value] : 0;
      const everyDay = total / allDay;

      return chartData.value.map((item:BurnDownType, index: number) => {
        return item.isFirstDate === 1 ?
          ['', total] :
          [item.formatTime, total - (everyDay * (index))];
      }) || [];
    });
    const realLineText = t('home.widgetPanel.realLine');
    const idealLineText = t('home.widgetPanel.idealLine');
    const setCurrentValue = (index: number) => {
      const t = showChartStatistic.value === 'issueCount' ?
        chartData.value[index].issueBurnupRangeVO.countValue :
        chartData.value[index].burnupRangeVo.countValue;
      const total = isNumber(t) ? t : 0;

      const a = isNumber(actualData.value[index][1]) ? Number(actualData.value[index][1]?.toFixed(2)) : '-';
      const i = isNumber(idealData.value[index][1]) ? Number(idealData.value[index][1]?.toFixed(2)) : '-';

      currentChartNumber.value = {
        total: index <= currentIndex ? total : '-',
        actualNumber: a,
        idealNumber: i,
        actualPercent: total > 0 && isNumber(a) ? Math.round(a / total * 100) : index <= currentIndex ? 0 : '-',
        idealPercent: total > 0 && isNumber(i) ? Math.round(i / total * 100) : index <= currentIndex ? 0 : '-',
        unfinishedIssueIds: chartData.value[index].unfinishedIssueIds || [],
        allIssueIds: chartData.value[index].allIssueIds || []
      };
    };
    const chartOption = computed(() => {
      return {
        grid: {
          left: '4px',
          right: '18px',
          bottom: '2%',
          top:'20px',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter: (e: any) => {
            setCurrentValue(e[0].dataIndex);
            if (e[0]?.dataIndex === 0) {
              return '';
            }
            return `<span>${e[0].data[0]}</span>`;
          },
          padding: [2, 5],
          confine: true,
          appendToBody: true
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          boundaryGap: false,
          axisLabel: {
            color: '#797A85',
            fontWeight: 400,
            fontSize: 12,
            formatter: (time: string) => {
              const t = time.split('-');
              return t.length >= 3 ? t[1] + '-' + t[2] : '';
            }
          }
        },
        yAxis: {
          type: 'value',
          nameTextStyle:{
            color:'#797A85',
            fontWeight:600,
            align:'left'
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee'
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#797A85',
            fontWeight: 500,
            fontSize: 12
          }
        },
        series: [
          {
            name: realLineText,
            type: 'line',
            areaStyle: {
              color: 'rgba(237, 149, 47, 0.08)'
            },
            itemStyle: {
              color: '#ED952F',
              borderWidth: 2
            },
            data: actualData.value,
            markArea: {
              silent: true,
              itemStyle: {
                color: 'rgba(237, 149, 47, 0.08)'
              },
              emphasis: {
                disabled: true
              },
              data: noWordDayRange
            },
            markLine: {
              symbol: 'none',
              label: { show: false },
              lineStyle: {
                color: '#CFCDE0',
                type: 'solid'
              },
              data: [{
                name: actualData.value[currentIndex]?.[0],
                xAxis: actualData.value[currentIndex]?.[0]
              }]
            }
          },
          {
            name: idealLineText,
            type: 'line',
            lineStyle: {
              type: 'dashed'
            },
            itemStyle: {
              color: '#CFCDE0'
            },
            showSymbol: false,
            data: idealData.value
          }
        ]
      };
    });
    const initECharts = (charts: any) => {
      setCurrentValue(currentIndex);
      charts.on('globalout', () => {
        setCurrentValue(currentIndex);
      });
    };
    const transformUserText = ({ user }: { user: UserProgressType }) => {
      return user.name;
    };
    const transformAllUserTotal = (users: UserProgressType[]) => {
      let r: number[] = [];
      users.forEach(u => {
        r = r.concat(u.issueIds || []);
      });
      return r;
    };
    const transformAllUserGroup = (users: UserProgressType[]): Array<GroupData> => {
      return users.map((item) => {
        return {
          title: item.name,
          issueIds: item.issueIds
        };
      });
    };
    const transformUserGroup = (user: UserProgressType): Array<GroupData> => {
      const keys: ('finishedIssueIds' | 'unfinishedIssueIds')[] = ['finishedIssueIds', 'unfinishedIssueIds'];
      return keys.map((key) => {
        return {
          title: processTranslateMap[key],
          issueIds: user[key]
        };
      });
    };
    const transformUnitByStatistic = (type: StatisticType, value: number | string) => {
      return unitTranslateMap[type](value || 0);
    };
    const calcUnitByStatistic = (type: StatisticType, value: string) => {
      if (type === 'point') {
        return `${t('saas.robotChat.progressPointKey')}: ${value}`;
      }
      if (type === 'labour') {
        return `${t('saas.robotChat.labourHours')}: ${value}`;
      }
      if (type === 'issueCount') {
        return `${t('saas.robotChat.progressWorkCount')}: ${value}`;
      }
      return value;
    };
    const segmentList = computed(() => {
      const s = summaryList.value.segments || [];

      if (!showSegment.value) {
        return s.slice(0, 10);
      }
      return s;
    });

    function changeShowSegment() {
      showSegment.value = !showSegment.value;
      const trackType = showSegment.value ? 'WebIM_Result_Expand' : 'WebIM_Result_Collapse';
      instance?.proxy.$track.send(trackType, {
        Intent_Type: '进度',
        Result_Type: '主要工作'
      }, true);
    }
    function changeShowUserProgress() {
      showUserProgress.value = !showUserProgress.value;
      const trackType = showUserProgress.value ? 'WebIM_Result_Expand' : 'WebIM_Result_Collapse';
      instance?.proxy.$track.send(trackType, {
        Intent_Type: '进度',
        Result_Type: '成员进度'
      }, true);
    }

    onMounted(async() => {
      showChartStatistic.value = workStatisticType.value;
      remainDay.value = await calcRemainingDays(reportData.value);
    });
    return {
      t,
      tc,
      reportType,
      reportData,
      remainDay,
      formatRemindTime,
      unitTranslateMap,
      transformUnitByStatistic,
      processTranslateMap,
      listMap: listMap.value.sort((a, b) => {
        return b.level - a.level;
      }),
      openAsideComponent,
      workStatisticType,

      riskSituation,
      riskUserList,
      riskUnit,
      levelUnit,
      overseas: isOverseasVersion,
      iconMap,
      transformMemberListNeedData,
      importECharts,
      chartOption,
      initECharts,
      currentChartNumber,
      RobotIcon,
      sourceMemberProgressUsers,
      memberProgressUsers,
      summaryList,
      showSegment,
      transformUserText,
      transformUserGroup,
      transformAllUserGroup,
      transformAllUserTotal,
      showChartStatistic,
      showUserProgress,
      calcUnitByStatistic,
      segmentList,
      chartError,
      chartData,
      changeShowSegment,
      changeShowUserProgress
    };
  }
});
